var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bpb-dialog-opener',{staticClass:"styled-button styled-button--icon-left t-99",attrs:{"target-id":`shop-dialog-${_vm.shopContext.itemId}`,"before-open-hook":_vm.addItemToCart}},[_c('bpb-icon',{attrs:{"icon":"i-cart","decorative":true}}),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }